import { FunctionComponent} from 'preact';

import styles from './../styles.module.scss';

const PlaceholderTile: FunctionComponent = () => (
  <div className={styles.topPageContainer}>
    <div className={styles.topPage}>
      <div className={styles.icon} />
      <span className={styles.label} style="opacity: 0">
        Placeholder
      </span>
    </div>
  </div>
);

export default PlaceholderTile;
